module.exports = "<div class=\"row\">\n  <div class=\"col-md-12\">\n    \n  </div>\n</div>"